import React, { FC } from 'react';
import { Route, Switch, useParams, useRouteMatch } from 'react-router-dom';
import { ACCESS_AUTHENTICATED } from '../../../services/route/permissions';
import AuthCheck from '../../helpers/AuthCheck/AuthCheck';
import MapSettingsMarkerGroupPage from './MapSettingsMarkerGroupPage';
import MapSettingsPage from './MapSettingsPage';

// This layer exists to forward on the route props to the old container component
const HackWrapper = ({
  render,
}: {
  render: (markerGroup: string) => React.ReactNode;
}) => {
  const { markerGroup } = useParams<{ markerGroup: string }>();
  return <>{render(markerGroup)}</>;
};

const MapSettingsFeature: FC = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route path={`${path}`} exact>
        <AuthCheck authentication={ACCESS_AUTHENTICATED}>
          <MapSettingsPage />
        </AuthCheck>
      </Route>

      <Route path={`${path}/:markerGroup`}>
        <AuthCheck authentication={ACCESS_AUTHENTICATED}>
          <HackWrapper
            render={(markerGroup: string) => (
              <MapSettingsMarkerGroupPage markerGroup={markerGroup} />
            )}
          />
        </AuthCheck>
      </Route>
    </Switch>
  );
};

export default MapSettingsFeature;
